import type { SurveyResponsePayload } from '@/modules/api';
import { toSingleAnswerValue, type Answers, type SurveyQuestion } from '@/modules/survey';

type BuildArgs = {
  answers: Answers;
  questions: SurveyQuestion[];
  userUuid: string;
  questionGroupUri: string;
  programUnitInstanceUri: string;
};

// Turns the answer map into the /surveycustomerresponse payload (mirrors
// Sparta's AssignedScreenerContainer.onContinue): choice answers go in `answer`
// (the choice resource URI), date answers go in `freeResponse`.
export function buildSurveyResponsePayload({
  answers,
  questions,
  userUuid,
  questionGroupUri,
  programUnitInstanceUri,
}: BuildArgs): SurveyResponsePayload {
  return {
    objects: Object.entries(answers).map(([questionUuid, rawValue]) => {
      const isDate = questions.find((q) => q.key === questionUuid)?.questionType === 'date';
      // Legacy assigned screeners are single-select — coerce to a string.
      const value = toSingleAnswerValue(rawValue);
      return {
        user: `/api/v3/user/${userUuid}/`,
        question: `/api/v3/surveyquestion/${questionUuid}/`,
        questionGroup: questionGroupUri,
        answer: isDate ? null : value,
        freeResponse: isDate ? value : null,
        programUnitInstance: programUnitInstanceUri,
      };
    }),
  };
}
